module.exports = __webpack_public_path__ + "img/cross-out.4e675394.svg";